/** @format */

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectCurrentUser } from '../../redux/user/user.selector';
import { Container } from '@mui/material';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import './newhire-button.styles.scss';
const NewHireButton = ({ currentUser }) => {
  return (
    <Container
      className="shadow"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#FFBFAF',
        height: '50vh',
        borderRadius: '50px',
        justifyContent: 'center',
      }}
    >
      <div style={{ paddingBottom: '50px', fontWeight: 'bold' }}>New Hire</div>
      <Link to="/automations/newhire">
        <motion.button
          className="modal-button"
          type="button"
          whileHover={{ scale: 1.1, cursor: 'pointer' }}
          whileTap={{ scale: 0.95 }}
        >
          {`Provisioning Tool`}
        </motion.button>
      </Link>

      {/* <motion.button
        className="modal-button"
        type="button"
        onClick={() => {
          axios({
            url: process.env.REACT_APP_LOCAL_URL + '/newhire/download',
            method: 'get',
          });
        }}
        style={{
          marginTop: '10px',
          marginBottom: '10px',
        }}
        whileHover={{ scale: 1.1, cursor: 'pointer' }}
        whileTap={{ scale: 0.95 }}
      >
        <a
          href={process.env.REACT_APP_LOCAL_URL + '/newhire/download'}
          download="newhire-credentials.csv"
          style={{ color: 'inherit', textDecoration: 'none' }}
        >{`Download CSV`}</a>
      </motion.button> */}
    </Container>
  );
};

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
});

export default connect(mapStateToProps)(NewHireButton);
